import { ShortBreakType } from 'app/constants/configuration/shortBreakType'

export const getShortBreakTypeName = (
  shortBreakType: ShortBreakType,
  translate: (string) => string,
): string => {
  const text: string = ShortBreakType[shortBreakType]
  return translate(`shortBreakType.${text}`)
}
